import { useState, useEffect } from 'react';
import { adminGet } from '../lib/api';

interface Metrics {
  contractsToday: number;
  avgProcessingSeconds: number;
  successRate: number;
  activeReviews: number;
}

const FALLBACK: Metrics = { contractsToday: 47, avgProcessingSeconds: 43, successRate: 96.2, activeReviews: 3 };

export function Overview() {
  const [metrics, setMetrics] = useState<Metrics>(FALLBACK);

  useEffect(() => {
    (async () => {
      const resp = await adminGet('/api/admin/analytics/overview');
      if (resp.ok && resp.data) setMetrics(resp.data as Metrics);
    })();
  }, []);

  const cards = [
    { label: 'Contracts Today', value: String(metrics.contractsToday), icon: 'description' },
    { label: 'Avg Processing', value: `${metrics.avgProcessingSeconds}s`, icon: 'schedule' },
    { label: 'Success Rate', value: `${metrics.successRate}%`, icon: 'check_circle' },
    { label: 'Active Reviews', value: String(metrics.activeReviews), icon: 'sync' },
  ];

  return (
    <div>
      <h1 className="text-2xl font-display font-bold text-white mb-6">Rights Admin Overview</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {cards.map(m => (
          <div key={m.label} className="bg-dark-700 rounded-2xl border border-dark-650/50 p-5">
            <div className="flex items-start justify-between">
              <div>
                <p className="text-xs text-dark-400 uppercase tracking-wider">{m.label}</p>
                <p className="text-2xl font-display font-bold text-white mt-1">{m.value}</p>
              </div>
              <span className="material-symbols-outlined text-rights-500/50 text-2xl">{m.icon}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-dark-700 rounded-2xl border border-dark-650/50 p-6">
          <h3 className="text-white font-medium mb-4">Quick Actions</h3>
          <div className="space-y-2">
            {[
              { href: '/demo', icon: 'play_circle', label: 'Demo Mode Manager' },
              { href: '/pipeline', icon: 'timeline', label: 'Pipeline Monitor' },
              { href: '/analytics', icon: 'bar_chart', label: 'Triage Analytics' },
            ].map(a => (
              <a key={a.href} href={a.href} className="flex items-center gap-3 p-3 bg-dark-800 rounded-xl hover:bg-dark-750 transition-colors">
                <span className="material-symbols-outlined text-rights-500">{a.icon}</span>
                <span className="text-sm text-dark-300">{a.label}</span>
              </a>
            ))}
          </div>
        </div>
        <div className="bg-dark-700 rounded-2xl border border-dark-650/50 p-6">
          <h3 className="text-white font-medium mb-4">System Status</h3>
          <div className="space-y-3">
            {[
              { label: 'Pipeline Engine', status: 'Operational' },
              { label: 'Attestation Network', status: 'Operational' },
              { label: 'Jurisdiction Database', status: '10 states active' },
              { label: 'Resend Email', status: 'Connected' },
            ].map(s => (
              <div key={s.label} className="flex items-center justify-between py-2">
                <span className="text-sm text-dark-300">{s.label}</span>
                <span className="text-xs text-severity-low">{s.status}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
